// Project Imports
import apiEndpoint from 'core/common/apiEndPoints';
import DashboardResource from 'core/resources/Dashboard';
import resources from 'core/resources/resources';
import { RolePermission } from 'interfaces/interface';
import type ResourceItem from 'interfaces/resource';
import axiosInstance from 'providers/axiosInstance/axiosInstance';
import useLogger from 'core/utils/useLogger';
import fetchPrograms from 'core/utils/fetchPrograms';
import OrgAccessControlResource from 'core/resources/orgAccessControl';

const fetchPermissions = async (
  setFilteredResources: React.Dispatch<React.SetStateAction<ResourceItem[]>>,
  setCrudPermission: React.Dispatch<React.SetStateAction<string[]>>,
  setModulePermission: React.Dispatch<React.SetStateAction<string[]>>,
  setUserDetails: React.Dispatch<React.SetStateAction<any[]>>,
  changeLanguage: React.Dispatch<React.SetStateAction<any>>,
  setCurrentLang: React.Dispatch<React.SetStateAction<any>>,
  connect: any,
  currentLang: any,
  token: any,
  setOrgId: React.Dispatch<React.SetStateAction<string>>,
  setProgramId: React.Dispatch<React.SetStateAction<string>>,
  setUserProgramList: React.Dispatch<React.SetStateAction<any[]>>,
  userSessionId: string
): Promise<void> => {
  try {
    const apiUrl = apiEndpoint.userEvalPermissionDetails;

    const response = await axiosInstance.get<RolePermission[]>(apiUrl);
    const responseData = (response.data as any)?.results;
    const crudPermission = responseData?.action_master_list;
    const userDetails = responseData?.user_details;

    // Fix: Use spread operator to merge arrays instead of +
    const allOtherPermission = [
      ...(responseData.screen_master_list || []),
      ...(responseData.module_master_list || []),
      ...(responseData.sub_module_master_list || []),
      ...(responseData.action_master_list || []),
    ];

    setModulePermission(allOtherPermission);
    setCrudPermission([
      ...crudPermission,
      'dashboard',
      'profile',
      'org_access_control',
    ]);

    // Now permissionIds is an array, so includes() will work correctly
    const newResources = resources.filter((resource: any) =>
      allOtherPermission.includes(resource.identifier)
    );
    if (userDetails?.is_system_admin) {
      const updatedResources = [...newResources];
      const incentiveIndex = updatedResources.findIndex(
        (resource: any) => resource.identifier === 'incentiveManagement'
      );
      if (incentiveIndex !== -1) {
        updatedResources.splice(
          incentiveIndex + 1,
          0,
          OrgAccessControlResource
        );
      } else {
        updatedResources.push(OrgAccessControlResource);
      }
      setFilteredResources([DashboardResource, ...updatedResources]);
    } else {
      setFilteredResources([DashboardResource, ...newResources]);
    }
    console.log(newResources, 'newResources');
    setUserDetails(userDetails);
    localStorage.setItem('userEmailId', userDetails?.user_mail_id || '');

    if (userDetails?.selected_language) {
      changeLanguage(userDetails?.selected_language);
      setCurrentLang(userDetails?.selected_language);
    }
    if (userDetails?.unique_id) {
      axiosInstance.defaults.headers.common = {
        Authorization: `Bearer ${token}`,
        'organization-id': userDetails?.organization_id,
        'Accept-Language': currentLang,
        'role-id': userDetails?.role_id,
        'iprogram-id': userDetails?.iprogram,
        'user-session-id': userSessionId,

        // 'iprogram-id': userDetails?.iprogram,
      };
      setOrgId(userDetails?.organization_id);
      setProgramId(userDetails?.iprogram);
      connect(userDetails?.unique_id, userDetails?.organization_id);
      await fetchPrograms(userDetails?.iprogram, setUserProgramList);
    }
  } catch (error) {
    const moduleWithAccess = ['dashboard', 'org_access_control'];
    const newResources = resources.filter((resource: any) =>
      moduleWithAccess.includes(resource.identifier)
    );
    setFilteredResources(newResources);

    if (error?.response?.data) {
      const logger = useLogger();
      logger('User permission details error :: ', error?.response?.data);
    }
  }
};

export default fetchPermissions;
